import React, { useEffect, useState } from "react";
import OrdersRating from "./OrdersRating";
import { FaCircle } from "react-icons/fa";

const OrderDetailsUserCard = ({ orderItem, id }) => {
  const [totalPrice, setTotalPrice] = useState(0);
  const [showRating, setShowRating] = useState(false);

  // console.log(orderItem, "orderItem");
  useEffect(() => {
    if (orderItem?.order) {
      const calculatedTotalPrice = orderItem.order.reduce((total, item) => {
        return total + item.unit_order.per_unit_price;
      }, 0);
      setTotalPrice(calculatedTotalPrice);
    }
  }, [orderItem]);

  // console.log(orderItem, "orderItem");
  return (
    <>
      <div className="d-flex flex-column justify-content-between">
        <div key={orderItem.id} className="col-12  ">
          <div className="d-flex flex-column flex-md-row justify-content-between  align-items-center mb-5">
            <div className="col-12 col-md-3 my-1">
              <img
                src="/images/storage5.jpg"
                className="img-fluid rounded "
                alt="indoor"
              />
            </div>
            <div className="col-12 col-md-8 gap-2 d-flex flex-column">
                <p className="mb-0 a-font" 
                    style={{fontSize:'24px' , fontWeight:700 , color:'#202224'}}>{orderItem.unit_order.name.toUpperCase()}</p>
                  <p className="mb-0 a-font" 
                    style={{fontSize:'16px' , fontWeight:400 , color:'#202224'}}>
                        {orderItem.unit_order.description}
                    </p>
                <p className="mb-0 a-font" 
                    style={{fontSize:'18px' , fontWeight:400 , color:'#202224'}}>
                        <span className="fw-bold">Starting Date: </span>
                        <span>{orderItem.starting_date}</span>
                    </p>
                    <p className="mb-0 a-font" 
                    style={{fontSize:'18px' , fontWeight:400 , color:'#202224'}}>
                    <span className="fw-bold">Ending Date: </span>
                    <span>{orderItem.ending_date}</span>
                  </p>

                    <div className="d-flex" style={{fontSize:'18px' , fontWeight:400 , color:'#202224'}}>
                    <span className="fw-bold a-font me-2">Payment Completed: </span>
                    <span
                      className={
                        orderItem.pending ? "text-success" : "text-danger"
                      }
                    >
                      {orderItem.pending ? " ✅" : " ❌"}
                    </span>
                    </div>

                    <div className="d-flex" style={{fontSize:'18px' , fontWeight:400 , color:'#202224'}}>
                    <span className="fw-bold a-font me-2">Booking: </span>
                    <span
                      className={
                        orderItem.completed ? "text-success" : "text-danger"
                      }
                    >
                      {orderItem.completed ? 
                      (<span 
                        style={{
                            fontWeight: '500',
                            fontSize: '12px',
                            backgroundColor: '#D9F7E866',
                            borderRadius: '118px',
                            color: '#5CDD9C',
                            padding: '2px 10px',
                            display: 'inline-flex',         
                            alignItems: 'center',    
                            justifyContent: 'center', 
                            border:'1px solid #5CDD9C',
                            gap:'3px',
                          }}>
                            <FaCircle size={6}></FaCircle>
                        Completed
                      </span>) 
                      : orderItem.pending ? 
                      (<span 
                        style={{
                            fontWeight: '500',
                            fontSize: '12px',
                            backgroundColor: '#D9F7E866',
                            borderRadius: '118px',
                            color: '#5CDD9C',
                            padding: '2px 10px',
                            display: 'inline-flex',         
                            alignItems: 'center',    
                            justifyContent: 'center', 
                            border:'1px solid #5CDD9C',
                            gap:'3px',
                          }}>
                            <FaCircle size={6}></FaCircle>
                        Active
                      </span>):
                      (<span 
                        style={{
                            fontWeight: '500',
                            fontSize: '12px',
                            backgroundColor: '#FFF3CD',
                            borderRadius: '118px',
                            color: 'rgb(115, 105, 38)',
                            padding: '2px 10px',
                            display: 'inline-flex',         
                            alignItems: 'center',    
                            justifyContent: 'center', 
                            border:'1px solid rgb(248, 225, 47)',
                            gap:'3px',
                          }}>
                            <FaCircle size={6}></FaCircle>
                        InProgress
                      </span>)}
                    </span>
                    </div>

                    <div className="d-flex" style={{fontSize:'18px' , fontWeight:400 , color:'#202224'}}>
                    <span className="fw-bold a-font me-2">Booking Finished: </span>
                    <span
                      className={
                        orderItem.completed ? "text-success" : "text-danger"
                      }
                    >
                      {orderItem.completed ? " ✅" : " ❌"}
                    </span>
                    </div>
              </div>
             
            </div>
            <div className="pt-4">
                {!orderItem.feedback && orderItem.completed && (
                  <div className="col-md-10 col-12">
                    {showRating ? (
                      <OrdersRating
                        id={orderItem.unit_order.storage_facility.id}
                        id_update={orderItem.id}
                        idDetails={id}
                      />
                    ) : (
                      <button
                        className="btn text-dark"
                        onClick={() => setShowRating(true)}
                      >
                        Give Rating
                      </button>
                    )}
                  </div>
                )}
              </div>
          </div>
        </div>
    </>
  );
};

export default OrderDetailsUserCard;
